import { CSSObject } from '@mui/material';

import { grey, red } from '../options/palette';
import transitions from '../options/transitions';

const inputLabel: CSSObject = {
  styleOverrides: {
    root: {
      'position': 'absolute',
      'zIndex': 1,

      'fontSize': '14px',
      'fontWeight': 600,

      'color': grey[400],

      'opacity': 1,

      'transform': 'translate(18px, 20px) scale(1)',

      'transition': `${transitions.duration?.short}ms ${transitions.easing?.easeOut}`,

      '&.Mui-focused': {
        fontSize: '12px',
        color: grey[400],

        transform: 'translate(18px, 12px) scale(1)'
      },

      '&.Mui-disabled': {
        opacity: 0.5,

        pointerEvents: 'none'
      },

      '&.Mui-error': {
        color: red[500]
      },

      '&.MuiInputLabel-asterisk': {
        color: red[500]
      },

      '&.MuiInputLabel-shrink': {
        fontSize: '12px',
        color: grey[400],

        transform: 'translate(18px, 12px) scale(1)'
      },

      '*, *::before, &::after': {
        transition: `${transitions.duration?.short}ms ${transitions.easing?.easeOut}`
      }
    }
  }
};

export default inputLabel;
